import { ReduxAction } from '../actions';
import { ActionTypes } from './actions';
import { groupUsageDataByMonth } from './helpers';
import { InstitutionUsageState, INITIAL_STATE } from './state';
import { InstitutionDailyUsageDataResponseKind } from './types';

export const InstitutionUsage = (
  state: InstitutionUsageState = INITIAL_STATE,
  action: ReduxAction
): InstitutionUsageState => {
  switch (action.type) {
    case ActionTypes.DAILY_USAGE_SUMMARY_LOAD_SUCCESS: {
      // eslint-disable-next-line camelcase
      const { subscriptionId, daily_usages } = action.data;
      return {
        ...state,
        dailyUsageSummary: {
          kind: InstitutionDailyUsageDataResponseKind.success,
          value: {
            subscriptionId,
            daily_usages: groupUsageDataByMonth(daily_usages),
          },
        },
      };
    }
    case ActionTypes.DAILY_USAGE_SUMMARY_LOAD_FAIL: {
      return {
        ...state,
        dailyUsageSummary: {
          kind: InstitutionDailyUsageDataResponseKind.forbidden,
        },
      };
    }
    case ActionTypes.INSTITUTION_CUMULATIVE_USAGE_LOAD_SUCCESS: {
      return {
        ...state,
        cumulativeUsageSummary: action.data,
      };
    }
    case ActionTypes.BILLING_PERIODS_LOAD: {
      return {
        ...state,
        billingPeriodSummary: {
          billingPeriods: action.data,
        },
      };
    }
    default: {
      return state;
    }
  }
};
